export const retrieveMainsLotsLocations = (
    lotsLocationsData: Record<string, any>[],
    isNotLocalizedIncluded: boolean
): Record<string, any>[] => {
    const mainsLotsLocationsCol = [];
    lotsLocationsData?.forEach((lot: Record<string, any>) => {
        // retrieve existant locations
        if (lot.locations && lot.locations.length > 0) {
            lot.locations.forEach((location: Record<string, any>) => {
                if (
                    !mainsLotsLocationsCol.some(
                        (colLoc: Record<string, any>) => colLoc.locationId === location.locationId
                    )
                ) {
                    mainsLotsLocationsCol.push({
                        locationId: location.locationId,
                        locationTitle: location.locationTitle,
                    });
                }
            });
        }

        if (isNotLocalizedIncluded) {
            // retrieve not localized
            if (lot.lotNoLocationsTotalExclVat) {
                const notLocalized = {
                    locationId: 'NOT_LOCALIZED',
                    locationTitle: 'Non localisé',
                };

                if (
                    !mainsLotsLocationsCol.some(
                        (colLoc: Record<string, any>) => colLoc.locationId === notLocalized.locationId
                    )
                ) {
                    mainsLotsLocationsCol.push(notLocalized);
                }
            }
        }
    });

    return mainsLotsLocationsCol;
};
